import { ITEM_STATUS } from '../constants'

const capitalize = (word) => {
  if (!word || typeof word !== 'string') {
    return ''
  }
  const firstLetter = word[0]
  return `${firstLetter.toUpperCase()}${word.slice(1)}`
}

const createOption = value => {
  return {
    name: capitalize(value),
    value
  }
}

export default Object.values(ITEM_STATUS).map(createOption)
